import { IFeatureFlag } from '@/types'
import { getApiBasepath } from 'api'

type FeatureFlags = {
  [key in IFeatureFlag['attributes']['name']]?: boolean
}

export const getFeatureFlags = async (query?: string) => {
  const headers = {
    'Content-Type': 'application/json',
  } as { 'Content-Type': string; Authorization?: string }
  const token = localStorage.getItem('token')
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  const response = await fetch(
    `${getApiBasepath()}/api/feature-flags?${query}`,
    {
      method: 'GET',
      headers: headers,
    }
  )
  const data = await response.json()
  return data as FeatureFlags
}
